import React, {useState} from 'react';
import {Usuario} from '../interfaces/usuarios';
import {Card, Image, Row, Col} from 'react-bootstrap';
import '../App.css';

const Data: React.FC<{usuario: Usuario}> = ({usuario}) => {
	const rut_foto = usuario.rut.split('-');
	const urlImagen = `https://estudiantes.uct.cl/fotos/0${rut_foto[0]}${rut_foto[1]}.jpg`;
	const [imageError, setImageError] = useState(false);
	const nombres = usuario.nombre.split(' ');
	return (
		<Row className='ps-sm-5 ps-md-5 flex-grow-1' style={{height: '100%'}}>
			<Col className='pb-5'>
				<Row>
					<Col>
						<Card
							style={{
								backgroundColor: 'rgba(255, 255, 255, 0)',
								border: 'none',
								color: 'white',
							}}>
							<Card.Body style={{padding: 0}}>
								<Card.Text as='div'>
									<div className='p-1'>
										<span className='letra-chica'>Identificación</span>
									</div>
									<div className='p-1'>
										<span className='letra-grande'>RUN: {usuario.rut}</span>{' '}
									</div>
									<div className='p-1'>
										<span className='letra-chica'>Nombre: </span>
										<br />
										{Array.from(
											{length: Math.ceil(nombres.length / 2)},
											(_, i) => nombres.slice(i * 2, i * 2 + 2),
										).map((nombrePar, indexPar) => (
											<span key={indexPar}>
												{nombrePar.map((nombre: string, index: number) => (
													<span className='letra-grande' key={index}>
														{nombre}{' '}
													</span>
												))}
											</span>
										))}
									</div>
									<div className='p-1'>
										<span className='letra-chica'>Número de registro: </span>
										<br />
										<span className='letra-grande'>
											{usuario.registro}
										</span>{' '}
										<br />{' '}
									</div>
									<div className='p-1'>
										<span className='letra-chica'>Carrera: </span>
										<br />
										<span className='letra-grande'>{usuario.carrera}</span>{' '}
										<br />{' '}
									</div>
								</Card.Text>
							</Card.Body>
						</Card>
					</Col>
					<Col className='d-flex align-items-center flex-row-reverse pe-5 me-5'>
						<Image
							className='imagen-estudiante'
							src={imageError ? require('../assets/user_PH.png') : urlImagen}
							onError={() => setImageError(true)}
							defaultValue={require('../assets/user_PH.png')}
							roundedCircle
						/>
					</Col>
				</Row>
			</Col>
		</Row>
	);
};

export default Data;
